<template>
  <div class="building-tooltip" v-if="building">
    <header class="building-tooltip__header">
      <h3 class="building-tooltip__number">
        {{ $t('building') }} {{ building }}
      </h3>
    </header>

    <div class="building-tooltip__info">
      <p class="building-tooltip__value">
        {{ $t('tooltip.flatNumber') }}: {{ getFlats(building) }}
      </p>

      <p class="building-tooltip__status">
        {{ $t('tooltip.available') }}: {{ getAvailableFlats(building) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    building: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
  },
  methods: {
    getFlats() {
      return this.$store.getters.GET_FILTERED_FLATS_BY_BUILDING(this.building)
        .length;
    },
    getAvailableFlats() {
      return this.$store.getters
        .GET_FILTERED_FLATS_BY_BUILDING(this.building)
        .filter(
          flat =>
            flat[this.flatProperties['status']] ==
            this.flatProperties['status_available']
        ).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.building-tooltip {
  padding: 0.2rem 0.3rem;
}

.building-tooltip__info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.building-tooltip__number {
  font-size: 20px;
  color: #000;
  font-weight: 700;
  white-space: nowrap;
}

.building-tooltip__value {
  font-size: 15px;
  color: #000;
  white-space: nowrap;
}

.building-tooltip__status {
  background: $available;
  width: auto;
  padding: 6px 13px;
  white-space: nowrap;
  font-size: 12px;
  margin-top: 4px;
}
</style>
